import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBlenderComponent } from './simple-icons-blender.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBlenderComponent ],
    exports:      [ SimpleIconsBlenderComponent ],
    bootstrap:    []
})
export class SimpleIconsBlenderModule {}
